module.exports = __webpack_public_path__ + "./img/cancel.9c8ac5d3f35484a4ce059907a7d286e2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/cancel.png
// module id = ./assets/images/cancel.png
// module chunks = 0